import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {MemberSearchModel} from "../member-search.model";
import {MemberSearchPageComponent} from "../member-search-page/member-search-page.component";
import {MemberEditPageComponent} from "../member-edit-page/member-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-member-no-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MemberNoSingleSelectEditControlComponent),
        provideSearchModel(MemberSearchModel)
    ]
})
export class MemberNoSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<MemberSearchModel> {
    constructor(model: MemberSearchModel, injector: Injector) {
        super(model, injector, "memberNo", "memberNoSummary");

        this.extendedSearchComponent = MemberSearchPageComponent;
        this.extendedEditComponent = MemberEditPageComponent;

        this.valueSearchField = "exactMemberNo";
        this.labelSearchField = "name";
    }
}
